class FlixThemeToggle extends HTMLElement {
  connectedCallback() {
    this._btn = this.querySelector('[data-flix-theme-btn]');
    this._dark = this.querySelector('[data-flix-icon-dark]');
    this._light = this.querySelector('[data-flix-icon-light]');
    if (!this._btn) return;
    this._sync();
    this._btn.addEventListener('click', () => this._toggle());
  }

  _current() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  _sync() {
    const mode = this._current();
    if (this._dark) this._dark.style.display = mode === 'dark' ? '' : 'none';
    if (this._light) this._light.style.display = mode === 'light' ? '' : 'none';
  }

  _toggle() {
    const next = this._current() === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('flix-theme', next); } catch (e) {}
    this._sync();
    document.dispatchEvent(new CustomEvent('flix:theme:change', { detail: { mode: next } }));
  }
}
customElements.define('flix-theme-toggle', FlixThemeToggle);
